import { Box, Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toSurveyStart } from '../../../utils/routes';
import { useTranslation } from 'react-i18next';
import { ArrowForward } from '@mui/icons-material';

export default function SurveyOnboarding(props) {

    const {t} = useTranslation()

    const navigate = useNavigate();

    return(
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Button startIcon=<ArrowForward/> variant="contained" onClick={() => navigate(toSurveyStart)}>{t("welcomeSurveyButton")}</Button>
        </Box>
    )
}